"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutDelivery = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _addressFormContext = require("../../contexts/addressFormContext");
var _models = require("../../models");
var _Loading = require("../Loading");
var _CheckoutDeliveryForApp = require("./CheckoutDeliveryForApp");
var _CheckoutDeliveryForSimplifiedCheckout = require("./CheckoutDeliveryForSimplifiedCheckout");
var _CheckoutDeliveryForSimplifiedCheckoutFlat = require("./CheckoutDeliveryForSimplifiedCheckoutFlat");
var _styles = require("./styles");
var _useCheckoutDelivery = require("./useCheckoutDelivery");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
} // TODO -- lazy loading for these 3 worth it?
const DeliveryOptionsDialog = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('../DeliveryOptions/DeliveryOptionsDialog'))));
const ShippingOfferDialog = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('../shippingOffer/ShippingOfferDialog'))));
const CheckoutDelivery = () => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const props = (0, _useCheckoutDelivery.useCheckoutDelivery)();
  const {
    deliveryOptionsDialogProps,
    isDeliveryOptionsOpen,
    isFlatSelection,
    isShippingOfferDialogOpen,
    isSimplifiedCheckout,
    mutateDeliveryOptions,
    onDeliveryItemActivation,
    rootRef,
    setActiveAddressFilter,
    setIsDisplayingAddresses,
    setIsSelectedAddressEdited,
    selectedItem,
    shippingOfferDialogProps
  } = props;
  const addressFormProviderProps = {
    mutateDeliveryOptions,
    onDeliveryItemActivation,
    setActiveAddressFilter,
    setIsDisplayingAddresses,
    setIsSelectedAddressEdited,
    selectedItemId: selectedItem?.addressId
  };
  const Content = isSimplifiedCheckout ? isFlatSelection ? _CheckoutDeliveryForSimplifiedCheckoutFlat.CheckoutDeliveryForSimplifiedCheckoutFlat : _CheckoutDeliveryForSimplifiedCheckout.CheckoutDeliveryForSimplifiedCheckout : _CheckoutDeliveryForApp.CheckoutDeliveryForApp;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_addressFormContext.AddressFormProvider, {
    ...addressFormProviderProps,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
      ref: isFlatSelection ? undefined : rootRef,
      ...getTestIdProps(_models.TestId.CheckoutDelivery),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Content, {
        ...props
      }), !isFlatSelection && isDeliveryOptionsOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
        fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LoadingOverlay, {
          open: true,
          ...getTestIdProps(_models.TestId.DeliveryOptionsComponentLoading),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {})
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(DeliveryOptionsDialog, {
          ...deliveryOptionsDialogProps
        })
      }) : null, isShippingOfferDialogOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
        fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LoadingOverlay, {
          open: true,
          ...getTestIdProps(_models.TestId.ShippingOfferModalLoading),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {})
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ShippingOfferDialog, {
          ...shippingOfferDialogProps
        })
      }) : null]
    })
  });
};
exports.CheckoutDelivery = CheckoutDelivery;